import React from 'react';
import jwt from 'jsonwebtoken';

import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import MoneyOffIcon from '@material-ui/icons/MoneyOff';
import Paper from '@material-ui/core/Paper';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TextField from '@material-ui/core/TextField';

import { PAGINATION } from '../../constants';
import API from '../../services/api';

import { getMoney, getItemValue, formatMoney } from '../helpers';
import CustomInputMoney from '../custom/inputmoney';
import CustomPopover from '../custom/popover';
import CustomAlert from '../custom/alert';

import CustomTableToolbar from './toolbar';
import CustomTableHead from './header';
import useStyles from './styles';

// eslint-disable-next-line
// String.prototype.capitalizeFirst = function() {
//   return this.charAt(0).toUpperCase() + this.slice(1);
// }

// eslint-disable-next-line
// String.prototype.capitalize = function() {
//   return this.toLowerCase().replace(/(^\w|\s\w)/g, s => s.toUpperCase());
// }

export default function TableCheck(props) {
  const classes = useStyles();
  const load = React.useRef(true);
  const [popup, setPopup] = React.useState(false);

  const [alert, setAlert] = React.useState({ open: false, message: '' });
  const [openDeposito, setOpenDeposito] = React.useState(false);
  const [openSaque, setOpenSaque] = React.useState(false);
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('name');
  const [page, setPage] = React.useState(0);
  const [reload, setReload] = React.useState(false);
  const [row, setRow] = React.useState(null);
  const [rows, setRows] = React.useState([]);
  const [rowsPerPage, setRowsPerPage] = React.useState(PAGINATION.PER_PAGE);
  const [rowsSelected, setRowsSelected] = React.useState([]);
  const { columns, fetch, icon, keys, title, toolbarbuttons } = props;

  const toolBarButtons1 = [
    {
      color: 'primary',
      title: 'Depositar',
      icon: <AttachMoneyIcon />,
      fab: false,
      onClick: () => setOpenDeposito(true),
    },
    {
      fab: false,
      color: 'secondary',
      title: 'Sacar',
      icon: <MoneyOffIcon />,
      onClick: () => setOpenSaque(true),
    },
  ];

  const toolBarButtons2 = [
    {
      fab: false,
      color: 'primary',
      title: 'Aprovar',
      icon: <CheckCircleIcon />,
      // onClick: () => setOpenDeposito(true),
    },
    {
      fab: false,
      color: 'secondary',
      title: 'Reprovar',
      icon: <RemoveCircleIcon />,
      // onClick: () => setOpenSaque(true),
    },
  ];

  // const [expanded, setExpanded] = React.useState(false);
  // const handleChange = (panel) => (event, isExpanded) => {
  //   setExpanded(isExpanded ? panel : false);
  // };

  const [anchorEl, setAnchorEl] = React.useState(null);

  function onReloadChanged() {
    if (reload) {
      const classe_ids = JSON.parse(API.encryptedSessionStorage.getItem('classe_ids', API.encryptedSessionStorage.getTokenData().uid));
      const profile_id = Number(API.encryptedSessionStorage.getItem('profile_id', API.encryptedSessionStorage.getTokenData().uid));
      const params = profile_id === 2 ? { profile_id: 3, classe_ids } : null;

      if (fetch) {
        fetch
          .index({ ...params })
          .then(onSuccess)
          .catch(onFailure);
      }
    }

    return function reloadChanged() {
      setReload(false);
      // setRowsSelected([]);
    };
  }

  function componentDidMount() {
    if (load.current) {
      setReload(true);
    }
    return function componentWillUnmount() {
      load.current = false;
    };
  }

  React.useEffect(componentDidMount, []);
  React.useEffect(onReloadChanged, [reload]);

  const handleRowClick = (item) => (event) => {
    event.stopPropagation();
    if (!popup) {
      // setAnchorEl(event.currentTarget);
      setRow(item);
      setPopup(true);
    } else {
      setAnchorEl(null);
      setPopup(false);
    }
  };

  // const handlePopoverClick = (item) => (event) => {
  //   event.stopPropagation();
  //   setRow(item);
  //   // setAnchorEl(event.currentTarget);
  // };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      setRowsSelected(rows);
    } else {
      setRowsSelected([]);
    }
  };

  const handleClick = (event, row) => {
    if (event.target.checked) {
      setRowsSelected([...rowsSelected, row]);
    } else {
      setRowsSelected(rowsSelected.filter((r) => r.id !== row.id));
    }
  };

  function onSuccess(response) {
    if (load.current && response.data) {
      console.log(response.data.data);
      setRows(response.data.data);
    }
  }

  function onFailure(error) {
    console.log(error.toString());
  }

  const handleChangePage = (event, newPage) => {
    event.stopPropagation();
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  function getLabelDisplayedRows({ from, to, count }) {
    const lastPage = Math.ceil(count / rowsPerPage) || 1;
    return <>{from > 0 ? `Exibindo: ${from} a ${to} Total: ${rows.length} Página ${page + 1} de ${lastPage}` : 'Nenhum resultado encontrado'}</>;
  }

  const DepositoDialog = ({ children, ...props }) => {
    const { open, setOpen } = props;
    const [description, setDescription] = React.useState('Atividade');
    const [value, setValue] = React.useState(0);
    const [validate, setValidate] = React.useState({});

    function handleCancel(event) {
      event.preventDefault();
      setOpen(false);
    }

    function handleDescriptionChange(event) {
      event.preventDefault();
      setDescription(event.target.value);
    }

    function handleConfirm(event) {
      event.preventDefault();
      const decoded = jwt.decode(sessionStorage.getItem('token'));
      const ids = rowsSelected.map((row) => row.id);

      if (!description) {
        setValidate({
          ...validate,
          description: 'Por favor, insira uma descrição',
        });
        return;
      }

      if (!value) {
        setValidate({ ...validate, valor: 'Por favor, insira um valor' });
        return;
      }

      const onSuccessDeposito = () => {
        const s = rowsSelected.length > 1 ? 's' : '';
        setAlert({
          open: true,
          message: rowsSelected.length + ' depósito' + s + ' no valor de ' + formatMoney(value) + ' enviado' + s + ' com sucesso para aprovação do administrador.',
        });
      };

      API.Depositos.lote({
        ids: ids,
        owners_id: decoded.uid,
        valor: value,
        description: description,
        state_id: 1,
      })
        .then(onSuccessDeposito)
        .catch(onFailure);
      setOpen(false);
    }

    function handleKeyDown(event) {
      // Esc = 27
      if (event.which === 27) {
        handleCancel(event);
      }
      // Enter = 13
      else if (event.which === 13) {
        event.preventDefault();
        handleConfirm(event);
      }
    }

    return (
      <Dialog open={open} fullWidth={true} maxWidth={'sm'} onClose={handleCancel} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">{'Depósito'}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {'Dejesa realizar o depósito para ' + rowsSelected.length + ' cliente' + (rowsSelected.length > 1 ? 's' : '') + ' selecionado' + (rowsSelected.length > 1 ? 's' : '') + '?'}
          </DialogContentText>
          <TextField
            helperText={validate.description || ''}
            error={validate.description ? true : false}
            onFocus={() => setValidate({ ...validate, description: null })}
            autoFocus={true}
            margin="dense"
            id="description"
            label="Descrição do depósito"
            type="text"
            value={description}
            fullWidth={true}
            onChange={handleDescriptionChange}
            onKeyDown={handleKeyDown}
          />
          <CustomInputMoney
            autoFocus={true}
            label="Valor do depósito"
            setValue={setValue}
            helperText={validate.valor || ''}
            error={validate.valor ? true : false}
            onFocus={() => setValidate({ ...validate, valor: null })}
            onKeyDown={handleKeyDown}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} color="primary">
            {'Cancelar'}
          </Button>
          <Button onClick={handleConfirm} color="primary">
            {'Confirmar'}
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  const SaqueDialog = ({ children, ...props }) => {
    const { open, setOpen } = props;
    const [description, setDescription] = React.useState('Compra');
    const [value, setValue] = React.useState(0);
    const [validate, setValidate] = React.useState({});

    function handleCancel(event) {
      event.preventDefault();
      setOpen(false);
    }

    function handleDescriptionChange(event) {
      event.preventDefault();
      setDescription(event.target.value);
    }

    function handleConfirm(event) {
      event.preventDefault();
      const decoded = jwt.decode(sessionStorage.getItem('token'));
      const ids = rowsSelected.map((row) => row.id);

      if (!description) {
        setValidate({
          ...validate,
          description: 'Por favor, insira uma descrição',
        });
        return;
      }

      if (!value) {
        setValidate({ ...validate, valor: 'Por favor, insira um valor' });
        return;
      }

      if (rowsSelected.find((row) => row.saldo < value)) {
        setValidate({
          ...validate,
          valor: 'Um ou mais clientes não possui saldo suficiente para esta operação, Por favor informe outro valor ou revise a seleção dos clientes',
        });
        return;
      }

      const onSuccessSaque = () => {
        setReload(true);
        const s = rowsSelected.length > 1 ? 's' : '';
        setAlert({
          open: true,
          message: rowsSelected.length + ' saque' + s + ' no valor de ' + formatMoney(value) + ' realizado' + s + ' com sucesso.',
        });
      };

      API.Saques.lote({
        ids: ids,
        owners_id: decoded.uid,
        valor: value,
        description: description,
      })
        .then(onSuccessSaque)
        .catch(onFailure);
      setOpen(false);
    }

    function handleKeyDown(event) {
      // Esc = 27
      if (event.which === 27) {
        handleCancel(event);
      }
      // Enter = 13
      else if (event.which === 13) {
        event.preventDefault();
        handleConfirm(event);
      }
    }

    return (
      <Dialog open={open} fullWidth={true} maxWidth={'sm'} onClose={handleCancel} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">{'Saque'}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            {'Dejesa realizar o saque para ' + rowsSelected.length + ' cliente' + (rowsSelected.length > 1 ? 's' : '') + ' selecionado' + (rowsSelected.length > 1 ? 's' : '') + '?'}
          </DialogContentText>
          <TextField
            helperText={validate.description || ''}
            error={validate.description ? true : false}
            onFocus={() => setValidate({ ...validate, description: null })}
            autoFocus={true}
            margin="dense"
            id="description"
            label="Descrição do saque"
            type="text"
            value={description}
            fullWidth={true}
            onChange={handleDescriptionChange}
            onKeyDown={handleKeyDown}
          />
          <CustomInputMoney
            autoFocus={true}
            label="Valor do saque"
            setValue={setValue}
            helperText={validate.valor || ''}
            error={validate.valor ? true : false}
            onFocus={() => setValidate({ ...validate, valor: null })}
            onKeyDown={handleKeyDown}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} color="primary">
            {'Cancelar'}
          </Button>
          <Button onClick={handleConfirm} color="primary">
            {'Confirmar'}
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  function descendingComparator(a, b, orderBy) {
    const A = getItemValue(a, keys(orderBy));
    const B = getItemValue(b, keys(orderBy));
    if (B < A) {
      return -1;
    }
    if (B > A) {
      return 1;
    }
    return 0;
  }

  function getComparator(order, orderBy) {
    return order === 'desc' ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);
  }

  function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <DepositoDialog open={openDeposito} setOpen={setOpenDeposito}></DepositoDialog>

        <SaqueDialog open={openSaque} setOpen={setOpenSaque}></SaqueDialog>

        <CustomPopover open={Boolean(anchorEl)} item={anchorEl} onClose={handlePopoverClose} data={row}></CustomPopover>

        <CustomAlert open={alert.open} onClose={() => setAlert({ ...alert, open: false })}>
          {alert.message}
        </CustomAlert>
        <CustomTableToolbar numSelected={rowsSelected.length} buttons={(toolbarbuttons === 1 && toolBarButtons1) || (toolbarbuttons === 2 && toolBarButtons2)}>
          {icon} {title}
        </CustomTableToolbar>

        <TableContainer>
          <Table className={classes.table} aria-labelledby="tableTitle" size={'small'} aria-label="enhanced table">
            <CustomTableHead
              classes={classes}
              numSelected={rowsSelected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={handleSelectAllClick}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
              columns={columns}
            />
            <TableBody>
              {stableSort(rows, getComparator(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  // const isItemSelected = rowsSelected.indexOf(row) !== -1;
                  const isItemSelected = rowsSelected.find((r) => row.id === r.id) !== undefined;

                  const labelId = `table-checkbox-${index}`;
                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      aria-checked={isItemSelected}
                      tabIndex={-1}
                      key={index}
                      selected={isItemSelected}
                      onClick={handleRowClick(row)}
                      // onMouseOver={handlePopoverClick(row)}
                      // onMouseLeave={handlePopoverClose}
                    >
                      {/*
                        <Accordion>
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-label="Expand"
                            aria-controls="additional-actions1-content"
                            id="additional-actions1-header"
                          >
                            <FormControlLabel
                              aria-label="Acknowledge"
                              onClick={(event) => event.stopPropagation()}
                              onFocus={(event) => event.stopPropagation()}
                              control={<Checkbox />}
                              label={getItemValue(row, ['name'])}
                            />
                          </AccordionSummary>
                          <AccordionDetails>
                            <Typography color="textSecondary">
                              {getItemValue(row, ['classe', 0, 'serie', 'school', 'name'])}
                            </Typography>
                          </AccordionDetails>
                        </Accordion>
                        */}
                      <TableCell key={'checkbox-' + index} padding="checkbox">
                        <Checkbox onClick={(event) => handleClick(event, row)} checked={isItemSelected} inputProps={{ 'aria-labelledby': labelId }} />
                      </TableCell>

                      {/* <TableCell component="th" id={labelId} scope="row" padding="none">
                        {getItemValue(row, keys('name'))}
                      </TableCell> */}

                      {/* <TableCell align="left">{getItemValue(row, keys('school'))}</TableCell> */}

                      {/* <TableCell align="left">{getItemValue(row, keys('serie')) + ' ' + getItemValue(row, keys('classe'))}</TableCell> */}

                      {/* <TableCell align="center">
                        <IconButton size="small" onClick={(e) => console.log(e)}>
                          <AttachMoneyIcon />
                        </IconButton>
                      </TableCell> */}

                      {columns.map((column) => {
                        return (
                          <TableCell component="th" scope="row" padding={column.disablePadding ? 'none' : 'default'} key={column.id + '-' + index} align={column.align || 'justify'}>
                            {Array.isArray(column.keys) && column.keys.length > 0 && (column.money ? getMoney(row, column.keys) : getItemValue(row, column.keys))}
                            {column.icon && (
                              <IconButton size="small" onClick={column.onClick(row)}>
                                {column.icon}
                              </IconButton>
                            )}
                          </TableCell>
                        );
                      })}

                      {/* <TableCell align="center"><IconButton size="small" onClick={e => console.log(e)}><DeleteIcon /></IconButton></TableCell> */}
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[5, 10, 15, 20, 25, 50, 100, 200]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          backIconButtonText={'Página anterior'}
          labelRowsPerPage={'Linhas por página: '}
          nextIconButtonText={'Próxima página'}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelDisplayedRows={getLabelDisplayedRows}
          classes={{
            root: classes.tablePagination,
            caption: classes.tablePaginationCaption,
            selectIcon: classes.tablePaginationSelectIcon,
            select: classes.tablePaginationSelect,
            actions: classes.tablePaginationActions,
          }}
        />
      </Paper>
    </div>
  );
}
